define.alias("shared/utils/canvas-video-player", "media/utils/canvas-video-player");